import { init } from '@nosto/preact'

import serpComponent from './serp'
import categoryComponent from './category'
import autocompleteComponent from './autocomplete'
import historyComponent from './history'
import { defaultConfig } from './config'

import './styles/index.css'

init({
    ...window.nostoTemplatesConfig,
    // serpComponent,
    // historyComponent,
    // autocompleteComponent,
    categoryComponent,
    inputCssSelector: '#search',
    contentCssSelector: '#content',
    serpUrlMapping: {
        query: 'q',
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    // serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'description', 'brand',
                'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount',
                'customFields.key', 'customFields.value'
            ],
            facets: ['*'],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            fields: [
                'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'brand',
                'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount'
            ],
            size: defaultConfig.autocompleteProductsSize,
        },
        keywords: {
            fields: [
                'keyword', '_highlight.keyword'
            ],
            size: defaultConfig.autocompleteKeywordsSize,
        }
    },
    comprtessUrlParameters: true,
    fallback: true,
    categoryCssSelector: '#content div[id$="__main"] .container.container--no-max.lightly-spaced-row-above',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
    const shopifyPagination = document.querySelector('.container.pagination-row[data-ajax-container]');
    if(shopifyPagination) {
        shopifyPagination.remove();
    }
})